import { CompleteUserInfo } from '../views/CompleteUserInfo/completeUserInfo.view';
import { ConfirmEmailView } from '../views/ConfirmEmail/confirmEmail.view';
import { SignInView } from '../views/SignIn/signIn.view';
import { RouteType, type } from './Router';
import { Routes } from './types';
import { SignUpView } from '../views/SignUp/signUp.view';
import { ForgetPasswordInsertEmailView } from '../views/ForgetPasswordInsertEmail/forgetPasswordInsertEmail.view';
import { ForgetPasswordCheckEmailView } from '../views/ForgetPasswordCheckEmail/forgetPasswordCheckEmail.view';
import { ChangePasswordView } from '../views/ChangePassword/changePassword.view';

export const authRoutes: RouteType[] = [
  {
    id: 'sign-up',
    path: Routes.SignUp,
    titleKey: 'pageTitles.signUp',
    type: type.AUTHENTICATION,
    component: SignUpView,
  },
  {
    id: 'sign-in',
    path: Routes.SignIn,
    titleKey: 'pageTitles.signIn',
    type: type.AUTHENTICATION,
    component: SignInView,
  },
  {
    id: 'confirm-email',
    path: Routes.ConfirmEmail,
    titleKey: 'pageTitles.confirmEmail',
    type: type.AUTHENTICATION,
    component: ConfirmEmailView,
  },
  {
    id: 'complete-user-info',
    path: Routes.CompleteUserInfo,
    titleKey: 'pageTitles.completeYourProfile',
    type: type.SECURED,
    component: CompleteUserInfo,
  },
  {
    id: 'recover-password-submit-email',
    path: Routes.RecoverPasswordInsertEmail,
    titleKey: 'pageTitles.insertEmailPasswordRecovery',
    type: type.AUTHENTICATION,
    component: ForgetPasswordInsertEmailView,
  },
  {
    id: 'recover-password-check-email',
    path: Routes.RecoverPasswordCheckEmail,
    titleKey: 'pageTitles.checkEmailPasswordRecovery',
    type: type.AUTHENTICATION,
    component: ForgetPasswordCheckEmailView,
  },
  {
    id: 'recover-password-change-password',
    path: Routes.RecoverPasswordChangePassword,
    titleKey: 'pageTitles.editPasswordPasswordRecovery',
    type: type.AUTHENTICATION,
    component: ChangePasswordView,
  },
];
